export default __webpack_public_path__ + "static/media/hf7.090e66d2.svg";